import isEqual from 'lodash/isEqual';
import { useEffect, useRef } from 'react';

import type { WithTagsInjectedProps } from 'hocs';

import { getNodeTagNames } from '../helpers/getNodeTagNames';

export const useTagFetch = <TAction = unknown>(
  tags: WithTagsInjectedProps['tags'],
  actions: Array<TAction> | null,
): void => {
  const prevActionsRef = useRef<Array<TAction> | null>(null);

  useEffect(() => {
    const { current: prevActions } = prevActionsRef;

    if (prevActions === actions) {
      return;
    }

    const { items, getItemsById } = tags;

    const nodeTagNames = getNodeTagNames(actions);
    const prevNodeTagNames = getNodeTagNames(prevActions);

    if (
      nodeTagNames.length &&
      // the actions can change for other reasons - e.g. changing x-y coords of the node
      // which means we need to deep compare the selected tags to avoid making too many requests
      (!isEqual(nodeTagNames.sort(), prevNodeTagNames.sort()) ||
        items.length === 0)
    ) {
      getItemsById(nodeTagNames);
    }

    prevActionsRef.current = actions;
  }, [actions, tags]);
};
